import React from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { Form, Icon, Input, Button, message, Row, Col, Carousel } from "antd";
import { Redirect } from "react-router-dom";
import { FORMAT_EMAIL } from '../../common/types/regularExpresionType';
import { ACCESO_APLICACION } from '../../common/types/parametroType';

import authService from "../../service/seguridad/authService";
import auth from "../../common/utility/auth";
import global from "../../common/utility/global";
import dialog from '../../common/utility/dialog';
import "./styles.css";

class Index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            flagRecuperar: false,
            loading: false,
            recaptchaRef: React.createRef(),
        };
    }

    fetchPages = (data) => {
        const pages = [];

        data.aplicaciones.forEach((aplicacion) => {
            aplicacion.modulos.forEach((modulo) => {
                modulo.paginas.forEach((pagina) => {
                    pages.push(pagina);
                });
            });
        });

        return pages;
    };

    handleLoginSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                this.setState({ loading: true });
                var recaptchaValue = this.state.recaptchaRef.current.getValue();
                /*       if (recaptchaValue === "") {
                          message.error("Confirmación de captcha incorrecta.");
                          this.setState({ loading: false });
                          return;
                      } */
                var dataSend = {
                    password: values.password.trim(),
                    ruc: values.ruc.trim(),
                    userName: values.userName.trim()
                };
                const response = await authService.signIn(dataSend);
                if (response.status === 200) {
                    var params = response.data.parametros;
                    var acceso = params.filter((m) => m.abreviatura === ACCESO_APLICACION)[0].valor;
                    if (acceso == "0" || acceso == "1") {
                        const now = new Date();
                        var totalTimeOut = 60000 * 360;/* Milisegundos * minutos */
                        response.data.ruc = values.ruc;
                        response.data.pages = this.fetchPages(response.data);
                        response.data.expiry = now.getTime() + totalTimeOut;
                        localStorage.setItem("user", JSON.stringify(response.data));
                        if (localStorage.getItem('isEpson') === null) {
                            localStorage.setItem('isEpson', false);
                        }

                    } else {

                        message.error("Solo tiene acceso a la aplicación móvil");

                    }


                } else if (response.status === 400) {
                    message.error(response.data.messages[0]);
                } else {
                    message.error("Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.");
                }

                this.setState({ loading: false });
            }
        });
    };

    correoCustomValidation = (rule, value, callback) => {
        var regexp = new RegExp(FORMAT_EMAIL);
        if (value.length === 0 || !regexp.test(value))
            callback('Formato de correo invalido.');

        callback();
    }

    handleRecuperarSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                this.setState({ loading: true });

                const response = await authService.recoverPassword(values);

                if (response.status === 200) {
                    this.setState({ flagRecuperar: false });
                    message.success('Se ha enviado su nueva contraseña a su correo electrónico.');
                } else if (response.status === 400) {
                    dialog.warning(<ul>{response.data.messages.map(item => (<li key={global.fetchUniqueCode()}>{item}</li>))}</ul>);
                } else {
                    message.error(
                        "Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde."
                    );
                }

                this.setState({ loading: false });
            }
        });
    };

    render() {
        if (auth.isAuthenticated()) return <Redirect to="/" />;

        const { getFieldDecorator } = this.props.form;

        return (
            <div id="pages-auth">
                <div className="content-logo-header">
                    <img src={require("../../assets/images/logo-header.png")} alt="Logo" />
                    <img src={require("../../assets/images/logo-iso.png")} alt="Logo" />
                </div>

                <div className="content-main">

                    <div className="content-border">
                        {/* <div className="main-top">
                            <div className="content-top">
                                <img className="logo" src={require("../../assets/images/logo-facturesoft.png")} alt="Logo" />
                            </div>
                        </div> */}
                        <div className="vertical-center">
                            <div className="text-center" style={{ width: '100%', zIndex: '1' }}>
                                <div>
                                    <img className="logo" src={require("../../assets/images/logo-facturesoft.png")} alt="Logo" />
                                </div>
                                <div>
                                    {/* <img className="logo" src={require("../../assets/images/logo-facturesoft.png")} alt="Logo" /> */}
                                    <span className="wellcome">{this.state.flagRecuperar ? 'Recuperar Contraseña' : 'Bienvenido'}</span>
                                </div>

                                <div>
                                    <span className="name-project-signin">{this.state.flagRecuperar ? 'Ingresa tus Datos' : 'Iniciar Sesión'}</span>
                                </div>

                                {
                                    !this.state.flagRecuperar ?

                                        <Form onSubmit={this.handleLoginSubmit} className="form-login mt-10">
                                            <Row justify="center">
                                                <Col className="gutter-row">
                                                    <Form.Item className="input-ruc">
                                                        {getFieldDecorator("ruc", {
                                                            rules: [{ required: true, message: "Por favor ingrese su ruc." }]
                                                        })(
                                                            <Input
                                                                addonBefore={<Icon type="file" style={{ color: "rgba(0,0,0,.25)" }} />}
                                                                placeholder="Ruc"
                                                            />
                                                        )}
                                                    </Form.Item>
                                                </Col>
                                            </Row>

                                            <Row justify="center">
                                                <Col className="gutter-row">
                                                    <Form.Item className="input-username">
                                                        {getFieldDecorator("userName", {
                                                            rules: [{ required: true, message: "Por favor ingrese un usuario." }]
                                                        })(
                                                            <Input
                                                                addonBefore={<Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />}
                                                                placeholder="Usuario"
                                                            />
                                                        )}
                                                    </Form.Item>
                                                </Col>
                                            </Row>

                                            <Row className="mb-10">
                                                <Col className="gutter-row">
                                                    <Form.Item className="input-password">
                                                        {getFieldDecorator("password", {
                                                            rules: [{ required: true, message: "Por favor ingrese una contraseña." }]
                                                        })(
                                                            <Input
                                                                addonBefore={<Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />}
                                                                type="password"
                                                                placeholder="Contraseña"
                                                            />
                                                        )}
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row type="flex" justify="center" className="mb-10">
                                                <ReCAPTCHA
                                                    ref={this.state.recaptchaRef}
                                                    sitekey="6LfDCVYUAAAAAMXzezGq9UkllGXJjoN25BLF5bXQ"
                                                />
                                            </Row>


                                            <Form.Item>
                                                <Button
                                                    loading={this.state.loading}
                                                    type="primary"
                                                    htmlType="submit"
                                                >
                                                    Ingresar
                                                </Button>
                                            </Form.Item>

                                            <div className="mt-15">
                                                <a className="not-selected" onClick={() => this.setState({ flagRecuperar: true })}>¿Olvidaste tu contraseña?</a>
                                            </div>

                                        </Form> :
                                        <Form onSubmit={this.handleRecuperarSubmit} className="form-login mt-10">
                                            <Row justify="center">
                                                <Col className="gutter-row">
                                                    <Form.Item className="input-ruc">
                                                        {getFieldDecorator("ruc", {
                                                            rules: [{ required: true, message: "Por favor ingrese su ruc." }]
                                                        })(
                                                            <Input
                                                                size="large"
                                                                addonBefore={<Icon type="file" style={{ color: "rgba(0,0,0,.25)" }} />}
                                                                placeholder="Ruc"
                                                            />
                                                        )}
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row justify="center">
                                                <Col className="gutter-row">
                                                    <Form.Item className="input-username">
                                                        {getFieldDecorator("userName", {
                                                            rules: [{ required: true, message: "Por favor ingrese un usuario." }]
                                                        })(
                                                            <Input
                                                                size="large"
                                                                autoComplete="off"
                                                                addonBefore={<Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />}
                                                                placeholder="Usuario"
                                                            />
                                                        )}
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row justify="center" className="mb-10">
                                                <Col className="gutter-row">
                                                    <Form.Item className="input-mail">
                                                        {getFieldDecorator("correo", {
                                                            rules: [{ required: true, message: "Por favor ingrese su correo." }]
                                                        })(
                                                            <Input
                                                                size="large"
                                                                autoComplete="off"
                                                                addonBefore={<Icon type="mail" style={{ color: "rgba(0,0,0,.25)" }} />}
                                                                placeholder="Correo"
                                                            />
                                                        )}
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Form.Item>
                                                <Button
                                                    loading={this.state.loading}
                                                    type="primary"
                                                    htmlType="submit"
                                                >
                                                    Recuperar Contraseña
                                                </Button>
                                            </Form.Item>

                                            <div className="mt-15">
                                                <a className="not-selected" onClick={() => this.setState({ flagRecuperar: false })}>Regresar al inicio de sesión</a>
                                            </div>
                                        </Form>
                                }



                            </div>
                        </div>

                        <div className="footer"><strong>Versión: {process.env.REACT_APP_VERSION}</strong><br />© A&C Facture Soft. Todos los derechos reservados {global.fetchCurrentYear()}</div>
                    </div>



                    <div className="content-border-2">
                        <Carousel autoplay effect="fade" className="login-img">
                            <div>
                                <img src={require("../../assets/images/login-background-acsoft-1.jpg")} className="login-img" alt="logo" />
                            </div>
                            <div>
                                <img src={require("../../assets/images/login-background-acsoft-2.png")} className="login-img" alt="logo" />
                            </div>
                        </Carousel>
                    </div>

                </div>
            </div>
        );
    }
}

export default Form.create()(Index);
